import { observeAutofillContainer } from '@/utils/autofillSync'

export const autofillSync = {
  mounted(el) {
    el._autofillSyncCleanup = observeAutofillContainer(el)
  },
  unmounted(el) {
    el._autofillSyncCleanup?.()
    delete el._autofillSyncCleanup
  }
}

export function registerAutofillSync(app) {
  app.directive('autofill-sync', autofillSync)
}
